import React, { useEffect } from "react";
import { message, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { usePayableModel } from "../payableModel";
import { IPayableDetail } from "../payableService";
import { formatNum } from "@/utils/utils";
export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys, setDetailedDialog
    } = usePayableModel();


    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IPayableDetail> = [
        {
            title: '序号',
            width: 60,
            align: "center",
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '采购合同号',
            width: 160,
            dataIndex: 'purchaseCode',
            fixed: "left",
            ellipsis: true,
        }, {
            title: '外贸合同号',
            width: 160,
            dataIndex: 'saleCode',
            fixed: "left",
            ellipsis: true,
        }, {
            title: '供应商名称',
            width: 160,
            dataIndex: 'name',
            ellipsis: true,
        }, {
            title: '费用类型',
            width: 160,
            dataIndex: 'typeName',
        }, {
            title: '合同总金额',
            width: 160,
            dataIndex: 'amountTotal',
            //有费用类型 和合同金额符号一致
            render: (t, r) => `${r.typeName ? r.currency : "￥"}${formatNum(t)}`
        },
        // {
        //     title: '不含税合同金额',
        //     width: 80,
        //     dataIndex: ""  //待确认
        // }, 
        {
            title: '结算日期',
            width: 200,
            dataIndex: "settlementTime",
            render: t => t ? t.substring(0, 10) : t
        }, {
            title: '结算金额',
            width: 180,
            dataIndex: 'amountTotal',
            render: (t, r) => `${r.currency}${formatNum(t)}`
        }, {
            title: '累计已付',
            width: 100,
            dataIndex: 'cumulative',
            render: (t, r) => `￥${formatNum(t)}`
        }, {
            title: '未付金额',
            width: 100,
            dataIndex: 'uncollected',
            //有费用类型 不展示未结算金额
            render: (t, r) => r.typeName ? "" : `￥${formatNum(t)}`
        }, {
            title: '付款详情',
            width: 80,
            align: "center",
            render: (t, r) => <span className="label-span" onClick={() => {
                // if (!r.code) {
                //     message.warning("该单据未结算");
                //     return;
                // }
                setDetailedDialog({ visible: true, row: r })
            }}>详情</span>
        },
    ];


    // //点击行选高亮
    // const onRow = (code: string) => {
    //     let findIndex = selectedRowKeys.indexOf(code);
    //     let newSelectedRowKeys = [...selectedRowKeys];
    //     if (findIndex === -1) {
    //         newSelectedRowKeys.push(code);
    //         setSelectedRowKeys(newSelectedRowKeys);
    //     } else {
    //         newSelectedRowKeys.splice(findIndex, 1);
    //         setSelectedRowKeys(newSelectedRowKeys);
    //     }
    // };


    return (
        <Table
            loading={loading}
            // rowSelection={{
            //     //全部选中时  (存string[])
            //     onSelectAll: (selected, selectedRows, changeRows) => {
            //         let changeRowId = changeRows.map(item => item.code).filter(item => item !== "listTotalAmount");
            //         selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
            //             : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
            //     },
            //     onSelect: (record) => onRow(record.code),
            //     selectedRowKeys: selectedRowKeys
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            // onRow={record => ({
            //     onClick: () => onRow(record.code),
            //     onContextMenu: (e) => {
            //         e.preventDefault();
            //         setSelectedRowKeys([record.code]);
            //     }
            // })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
